import { lazy } from 'react'
import { RouteObject, Navigate } from "react-router-dom"
import PageGuard from "../guards/PageGuard"
import CreateTenantRoute from "../features/CreateTenant/routes"
import {TenantListRoute} from "../features/TenantListing/routes"
import DataViewRoute from "../features/DataPreview/routes"
import DashboardLayout from "../layouts/Dashboard/Dashboard"
import {
    ApiDashboardRoute,
    IntegrationDashboardRoute,
    ServiceStatusRoute,
    ErrorDashboardRoute,
} from '../features/OperationDashboard/routes'
import { SubscriptionRoute } from '../features/Subscriptions/routes'
import {
    CreateSubscriptionRoute,
    EditSubscriptionRoute,
} from '../features/Subscriptions/components/CreateSubscription/routes'
import TenantFormRoute from '../features/TenantForm/routes/TenantForm'
import MarkPackagesPaidRoute from '../features/MarkPackagesPaid/routes'
import SupersetPresetsRoute from '../features/SupersetPresets/routes'
import ConfigDocsRoute from '../features/ConfigDocs/routes'
import HelpVideosRoute from '../features/HelpVideos/routes'
import {
    HomePageRoute,
    TenantSetupHubRoute,
    TenantSetupListingLegacyRoute,
    TenantSetupListingRoute,
} from '../features/TenantSetup/routes'
import { Tenant360Routes } from '../features/Tenant360/routes'
import InvoiceDashboardRoute from '../features/InvoiceDashboard/routes'
import TenantAnalyticsRoute from '../features/TenantAnalytics/routes'
import CustomerSuccessDashboardRoute from "../features/CSDashboard/routes"
import { BreachConsoleRoute } from '../features/BreachConsole/routes'
import {
    DataSyncDocsRoute,
    DataSyncListingRoute,
    EtpSyncFeedConfigRoute,
    EtpSyncWorkspaceIndexRoute,
    EtpSyncWorkspaceRoute,
} from '../features/DataSync/routes'
import { FinanceOnboardingRoute } from '../features/FinanceOnboarding/routes'


const EmailValidationAdminPage = lazy(
    () => import('../features/EmailValidation/pages/EmailValidationAdminPage')
)

const routesPages: RouteObject[] = [
    HomePageRoute,
    TenantSetupListingRoute,
    TenantSetupListingLegacyRoute,
    CreateTenantRoute,
    TenantListRoute,
    ApiDashboardRoute,
    IntegrationDashboardRoute,
    ServiceStatusRoute,
    ErrorDashboardRoute,
    DataViewRoute,
    SubscriptionRoute,
    CreateSubscriptionRoute,
    EditSubscriptionRoute,
    TenantFormRoute,
    Tenant360Routes,
    TenantSetupHubRoute,
    InvoiceDashboardRoute,
    MarkPackagesPaidRoute,
    SupersetPresetsRoute,
    ConfigDocsRoute,
    HelpVideosRoute,
    TenantAnalyticsRoute,
    CustomerSuccessDashboardRoute,
    BreachConsoleRoute,
    DataSyncListingRoute,
    DataSyncDocsRoute,
    EtpSyncFeedConfigRoute,
    EtpSyncWorkspaceRoute,
    EtpSyncWorkspaceIndexRoute,
    {
        path: 'email-validation',
        element: <EmailValidationAdminPage />,
    },
    {
        path: 'tenants',
        element: <Navigate to="/" replace />,
    },
    {
        path: 'tenant',
        element: <Navigate to="/" replace />,
    },
]


const Routes: RouteObject[] = [
    // Public, unauthenticated. Must stay outside DashboardLayout.
    FinanceOnboardingRoute,
    {
        path: '/',
        element: <DashboardLayout />,
        children: [
            {
                path: '/',
                element: <PageGuard />,
                children: routesPages,
            },
        ],
    },
]

export default Routes
